export class ServiceStationNameValueConverter {
  public toView(value) {
    return value
      .replace('Mørenot ', '')
      .replace(' AS', '');
  }
}
